import qs from "qs";

import { encodeCompressed } from "../../lib/hooks/useURLState";
import { routes } from "../../lib/routes";
import { LeadSortBy, LeadSortOrder } from "../../lib/types/graphQLEnums";
import { AssigneeFilterValue } from "../form_components/dropdown_list_selects/UserDropdownFilter";

export function generateLeadsSearchUrl(params: {
  stageIds?: string[];
  assignee?: AssigneeFilterValue;
  teamIds?: string[];
}): string {
  const filterValue = {
    stageIds: params.stageIds,
    assignee: params.assignee,
    teamIds: params.teamIds,
    orderBy: LeadSortBy.UpdatedAt,
    order: LeadSortOrder.Desc,
  };
  const queryParams = qs.stringify(
    {
      leadFilters: encodeCompressed(filterValue),
    },
    { arrayFormat: "brackets", encodeValuesOnly: true, addQueryPrefix: true },
  );
  return `${routes.leads}${queryParams}`;
}
